const editorViewRegistry = new Map<string, any>();

export const registerEditorView = (id: string, editor: any) => {
  editorViewRegistry.set(id, editor);
};

export const getEditorView = (id: string) => editorViewRegistry.get(id);

export const unregisterEditorView = (id: string) => {
  editorViewRegistry.delete(id);
};
